import { oldToNewStyleTokenTickers, newToOldStyleTokenTickers, } from '@exodus/asset-legacy-token-name-mapping';
class Mapper {
    constructor() { }
    toProvider(ticker) {
        return newToOldStyleTokenTickers[ticker] ?? ticker;
    }
    fromProvider(legacyTicker) {
        return oldToNewStyleTokenTickers[legacyTicker] ?? legacyTicker;
    }
}
const assetMapper = new Mapper();
class AssetAdapter {
    #assetsModule;
    constructor(params) {
        this.#assetsModule = params.assetsModule;
    }
    toExchangeId(walletId) {
        return assetMapper.toProvider(walletId);
    }
    toWalletId(exchangeId) {
        const asset = Object.values(this.#assetsModule.getAssets()).find((asset) => asset.ticker === exchangeId);
        if (asset) {
            return exchangeId;
        }
        return assetMapper.fromProvider(exchangeId);
    }
}
export default AssetAdapter;
